export interface CollectionItem {
  id: string;
  name: string;
  desc: string;
  entries: number;
  tags: string[];
  updated: string;
}

export const collections: CollectionItem[] = [
  {
    id: "c1",
    name: "入口推荐合集",
    desc: "把口碑稳定、长期可用的入口单独拎出来做一份合集，省去逐个试错的时间。",
    entries: 48,
    tags: ["推荐", "长期有效"],
    updated: "今天 11:40",
  },
  {
    id: "c2",
    name: "吃瓜大全汇总",
    desc: "按事件主题横向汇总，一个主题下挂多个入口，想看深一点或浅一点都能挑。",
    entries: 63,
    tags: ["大全", "按主题"],
    updated: "今天 10:22",
  },
  {
    id: "c3",
    name: "速报短讯合集",
    desc: "只收一句话就能看完的短讯入口，通勤路上刷两分钟就能跟上进度。",
    entries: 37,
    tags: ["短讯", "随时看"],
    updated: "今天 09:55",
  },
  {
    id: "c4",
    name: "归档补课合集",
    desc: "把已经过去但值得回头看的旧料按时间归档，补课不用东拼西凑找线索。",
    entries: 52,
    tags: ["老瓜", "时间线"],
    updated: "昨天 21:10",
  },
  {
    id: "c5",
    name: "图集与视频合集",
    desc: "偏视觉的入口归作一堆，图集、视频、长贴分区摆放，想看哪种直接点。",
    entries: 29,
    tags: ["图集", "视频"],
    updated: "昨天 18:36",
  },
  {
    id: "c6",
    name: "冷门口袋名单",
    desc: "更新不快但内容干净的冷门站入口，数量不多，放在这里当作备选口袋。",
    entries: 21,
    tags: ["小众", "备选"],
    updated: "昨天 14:02",
  },
];